import React, { Component } from 'react';
import SprintList from "../components/sprintlist";
import SprintService from '../service/sprintService';
import SprintStatusService from "../service/sprintStatusService";
import NavigationBar from '../components/navigationBar';

export default class OpenSprintSiteOverview extends Component {

    constructor(props) {
        super(props);
        this.sprintService = new SprintService();
        this.sprintStatusService = new SprintStatusService();
        this.state = {
            sprints: [],
            sprintStatuses: [],
            sprintName: ""
        }

        this.handleChange = this.handleChange.bind(this);

        this.createSprint = this.createSprint.bind(this);
    }

    async getSprintStatuses() {
        let result = await this.sprintStatusService.getSprintkStatuses();
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                sprintStatuses: result
            })
        }
    }

    handleChange(event) {
        this.setState({
            sprintName: event.target.value
        });
    }

    async createSprint(event) {
        event.preventDefault();
        if (this.state.sprintName === "") {
            alert("Sprint Name cannot be empty!");
            return;
        }

        let result = await this.sprintService.createNewSprint(this.props.match.params.projectID, this.state.sprintName);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.hideOverlay();
            this.getSprints();
        }
    }

    async getSprints() {
        let result = await this.sprintService.retrieveOpenSprints(this.props.match.params.projectID);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                sprints: result
            })
        }
    }

    showOverlay() {
        document.getElementById("overlay").style.display = "block";
    }

    hideOverlay() {
        document.getElementById("overlay").style.display = "none";
    }

    componentDidMount() {
        this.getSprints();
        this.getSprintStatuses();
    }

    render() {
        const sprints = this.state.sprints;
        if (!sprints) return null;
        const sprintStatuses = this.state.sprintStatuses;
        if (sprintStatuses.length === 0) return null;

        return (
            <div className="body">
                <div id="overlay">
                    <div id='LoginDiv' className='content'>
                        <button onClick={this.hideOverlay}>Back</button><br />
                        <center><h1>New Sprint</h1></center>
                        <form action="#" onSubmit={(event) => { this.createSprint(event) }}>
                            <label htmlFor="SprintName"><b>Sprint Name:</b></label><br />
                            <input type="text" name="SprintName" value={this.state.sprintName} onChange={this.handleChange} required /><br />
                            <button type="submit">Create Sprint</button>
                        </form>
                    </div>
                </div>
                <NavigationBar {...this.props} />
                <main>
                    <button onClick={this.showOverlay}>Create New</button>
                    <p>Open Sprints</p>
                    <SprintList sprints={this.state.sprints} sprintStatuses={this.state.sprintStatuses} projectUUID={this.props.match.params.projectID} />
                </main>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/sites/openSprintSiteOverview.js